// const auth = require('./utils/auth')
module.exports = {
  title: '',
  fixedHeader: true,
  sidebarLogo: true,
  tagsView: true,
  filePath: `${process.env.VUE_APP_BASE_API}`,
  uploadConfig: {
    imageAction: `${process.env.VUE_APP_BASE_API}/main/upload`,
    fileAction: `${process.env.VUE_APP_BASE_API}/main/uploadFile`,
    pictureAction: `${process.env.VUE_APP_BASE_API}/main/uploadOss`,
    maxFileSize: 500
  }
}
